import React from 'react';
import { Bell, X, CheckCircle2 } from "lucide-react";

const NewsModal = ({ sysConfig, onClose }) => {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-in fade-in duration-300">
      <div className="bg-white w-full max-w-lg rounded-2xl shadow-2xl overflow-hidden animate-in zoom-in-95 duration-300">
        
        <div className="bg-yellow-400 p-4 flex justify-between items-center">
          <h3 className="text-lg font-black text-white flex items-center gap-2">
            <Bell className="fill-white" /> 系統推播通知
          </h3>
          <button onClick={onClose} className="p-1 bg-white/20 rounded-full hover:bg-white/40 transition-colors text-white">
            <X size={20} />
          </button>
        </div>

        <div className="p-6 max-h-[60vh] overflow-y-auto space-y-6 select-none">
          {sysConfig?.announcement && (
            <div className="space-y-2">
              <h4 className="font-bold text-slate-800 flex items-center gap-2 border-b pb-1">
                📢 最新公告
              </h4>
              <p className="text-sm text-slate-600 whitespace-pre-wrap leading-relaxed bg-yellow-50 p-3 rounded-xl border border-yellow-100">
                {sysConfig.announcement}
              </p>
            </div>
          )}

          {sysConfig?.notices && (
            <div className="space-y-2">
              <h4 className="font-bold text-slate-800 flex items-center gap-2 border-b pb-1">
                📋 教室須知
              </h4>
              <div className="text-xs text-slate-500 space-y-1 bg-slate-50 p-3 rounded-xl border border-slate-100">
                {(Array.isArray(sysConfig.notices) ? sysConfig.notices : (sysConfig.notices || "").split('\n')).map((line, i) => {
                   const txt = typeof line === 'string' ? line : "";
                   return txt.trim() && (
                    <p key={i} className="flex items-start gap-2">
                      {txt}
                    </p>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        <div className="p-4 border-t border-slate-100 bg-slate-50 flex justify-center">
          <button onClick={onClose} className="w-full py-3 bg-slate-900 text-white font-bold rounded-xl shadow-lg hover:bg-slate-800 transition-all flex items-center justify-center gap-2">
            <CheckCircle2 size={18} /> 我知道了，開始解題！
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewsModal;
